import styled from 'styled-components';

export const Container = styled.section`
  margin: 0;

  .hefesto-modal__header {
    margin-bottom: 12px;
    h3 {
      font-size: 20px;
      line-height: 28px;
      color: #495961;
      margin: 0;
    }
  }
`;
